import Signatures from "components/Signatures/Signatures";
import React from "react";

function EmailSignaturePage() {
  return <Signatures />
}

export default EmailSignaturePage;
